import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { discountConstants, discountModels } from '..';

export const usePrepaymentCalculate = () =>
  useQuery<{ calculateTime: discountModels.PrepaymentCalculate }>({
    queryKey: [discountConstants.queryKeys.DISCOUNT_CONFIG_PREPAYMENT_CALCULATE],
    queryFn: async () => {
      const res = await $api.get('/v1/discount/config/prepayment-calculate');

      return res?.data?.data;
    }
  });
